var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveSpeakerMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.76 1.80029H3.23999C2.4447 1.80029 1.79999 2.445 1.79999 3.24029V9.36029C1.79999 10.1556 2.4447 10.8003 3.23999 10.8003H14.76C15.5553 10.8003 16.2 10.1556 16.2 9.36029V3.24029C16.2 2.445 15.5553 1.80029 14.76 1.80029Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49999 12.5999H2.69999C2.20293 12.5999 1.79999 13.0028 1.79999 13.4999V15.2999C1.79999 15.7969 2.20293 16.1999 2.69999 16.1999H4.49999C4.99704 16.1999 5.39999 15.7969 5.39999 15.2999V13.4999C5.39999 13.0028 4.99704 12.5999 4.49999 12.5999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90001 12.5996H8.10001C7.60296 12.5996 7.20001 13.0026 7.20001 13.4996V15.2996C7.20001 15.7967 7.60296 16.1996 8.10001 16.1996H9.90001C10.3971 16.1996 10.8 15.7967 10.8 15.2996V13.4996C10.8 13.0026 10.3971 12.5996 9.90001 12.5996Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 12.5996H13.5C13.003 12.5996 12.6 13.0026 12.6 13.4996V15.2996C12.6 15.7967 13.003 16.1996 13.5 16.1996H15.3C15.7971 16.1996 16.2 15.7967 16.2 15.2996V13.4996C16.2 13.0026 15.7971 12.5996 15.3 12.5996Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSpeakerMode);
export default __webpack_public_path__ + "static/media/active-speaker-mode.2f558c26.svg";
export { ForwardRef as ReactComponent };